<template>
  <section id="galeria" class="gallery-wrapper">
    <v-container>
      <!-- Encabezado -->
      <div class="gallery-header text-center">
        <h2 class="section-title">Nuestros <span class="highlight">Proyectos</span></h2>

      </div>

      <!-- Sección de Videos Destacados -->
      <div class="featured-videos mb-12">
        <h3 class="video-section-title">Descubre nuestro trabajo en acción</h3>
        <v-row class="justify-center">
          <v-col cols="12" md="6" class="video-col">
            <div class="youtube-video-container">
              <iframe
                  src="https://www.youtube.com/embed/Qzb9d1X5u1A?modestbranding=1&rel=0"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  class="youtube-iframe"
              ></iframe>
              <div class="video-info">
                <h4>Instalación de HBP3000LV</h4>
                <p>Proceso completo de implementación</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="video-col">
            <div class="youtube-video-container">
              <iframe
                  src="https://www.youtube.com/embed/_PzYiJ5ku6w?modestbranding=1&rel=0"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  class="youtube-iframe"
              ></iframe>
              <div class="video-info">
                <h4>Instalación HBP1800 OLV</h4>
                <p>Proceso completo de implementación</p>
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- Cards de proyectos -->
        <v-row class="justify-center">
          <v-col
              v-for="(project, pIndex) in projects"
              :key="'project-'+pIndex"
              cols="12"
              md="10"
              lg="8"
          >
            <v-card
                class="project-card"
                :class="{ 'expanded': expandedProject === pIndex }"
            >
              <!-- Encabezado del proyecto -->
              <div @click="toggleProject(pIndex)" class="project-header">
                <h3 class="project-title">{{ project.name }}</h3>
                <p class="project-description">{{ project.description }}</p>
                <div class="tech-wrapper">
                  <v-chip
                      v-for="(tech, tIndex) in project.technologies"
                      :key="'tech-'+tIndex"
                      class="tech-chip mx-1 my-1"
                      small
                  >
                    {{ tech }}
                  </v-chip>
                </div>
                <v-icon class="expand-icon">
                  {{ expandedProject === pIndex ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>

              <!-- Carousel de imágenes (visible solo cuando está expandido) -->
              <v-slide-group
                  v-if="expandedProject === pIndex"
                  class="pa-4"
                  show-arrows
              >
                <v-slide-item
                    v-for="(item, iIndex) in project.items"
                    :key="'item-'+iIndex"
                >
                  <div class="image-slide">
                    <v-hover v-slot="{ isHovering }">
                      <v-card
                          class="image-card"
                          @click="openLightbox(project, item)"
                      >
                        <div class="image-container">
                          <img
                              :src="item.src"
                              :alt="item.title"
                              class="gallery-image"
                              loading="lazy"
                          >
                          <div
                              class="image-overlay"
                              :class="{ 'active': isHovering }"
                          >
                            <v-icon v-if="item.type === 'video'" size="48">mdi-play-circle</v-icon>
                            <span class="media-caption">{{ item.title }}</span>
                          </div>
                        </div>
                      </v-card>
                    </v-hover>
                  </div>
                </v-slide-item>
              </v-slide-group>
            </v-card>
          </v-col>
        </v-row>
        <!-- Lightbox -->
        <v-dialog v-model="lightboxActive" max-width="1200" @click:outside="closeLightbox">
          <v-card class="lightbox-card">
            <v-card-actions class="lightbox-actions">
              <v-spacer></v-spacer>
              <v-btn icon @click="closeLightbox">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-actions>

            <v-card-text class="lightbox-content">
              <div class="media-container">
                <img
                    v-if="currentItem.item.type === 'image'"
                    :src="currentItem.item.src"
                    class="lightbox-image"
                >
                <video
                    v-else
                    controls
                    class="lightbox-video"
                >
                  <source :src="currentItem.item.video" type="video/mp4">
                </video>
              </div>

              <div class="lightbox-details pa-4 ">
                <h3 class="details-title">{{ currentItem.project.name }}</h3>
                <p><strong>Cliente:</strong> {{ currentItem.project.client }}</p>
                <p><strong>Ubicación:</strong> {{ currentItem.project.location }}</p>
                <p><strong>Descripción:</strong> {{ currentItem.item.description }}</p>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </section>
</template>

<script>
//import VideoCard from '@/components/VideoCard.vue'

export default {
  name: 'GaleriaComp',
  components: {
    //VideoCard
  },
  data() {
    return {
      expandedProject: null,
      lightboxActive: false,
      currentItem: {
        project: {},
        item: {}
      },
      // video1Source: require('@/assets/video1-optimized.mp4'),
      // video2Source: require('@/assets/video2-optimized.mp4'),
      projects: [
        {
          id: 1,
          name: 'Estación de Carga Solar',
          client: 'Universidad Ciencias Médicas de La Habana',
          location: 'La Habana, Cuba',
          description: 'Sistema fotovoltaico para carga de vehículos eléctricos',
          technologies: ['Paneles 450W', 'Inversores híbridos', 'Baterías LiFePO4'],
          items: [
            {
              src: require('@/assets/galeria/1.jpg'),
              title: 'Instalación de paneles',
              description: 'Montaje de los paneles solares',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/3.jpg'),
              title: 'Conexiones Eléctricas',
              description: 'Instalación de las conexiones eléctricas del SFV',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/4.jpg'),
              title: 'Inversor',
              description: 'Inversores y banco de baterías',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/6.jpg'),
              title: 'Estación terminada',
              description: 'Vista final del sistema de carga instalado',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/11.jpg'),
              title: 'Estación terminada',
              description: 'Vista final del sistema de carga instalado',
              type: 'image'
            }
          ]
        },
        {
          id: 2,
          name: 'Sistema Solar Fotovoltaico Híbrido',
          client: 'Facultad Salvador Allende',
          location: 'La Habana, Cuba',
          description: 'Sistema fotovoltaico para carga consumo de la facultad',
          technologies: ['Paneles 450W', 'Inversores híbridos', 'Baterías LiFePO4'],
          items: [
            {
              src: require('@/assets/galeria/14.jpg'),
              title: 'Instalación de paneles',
              description: 'Montaje de los paneles solares',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/20.jpg'),
              title: 'Conexiones Eléctricas',
              description: 'Instalación de las conexiones eléctricas del SFV',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/16.jpg'),
              title: 'Inversor',
              description: 'Inversores y banco de baterías',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/19.jpg'),
              title: 'Estación terminada',
              description: 'Vista final del sistema de carga instalado',
              type: 'image'
            },
            {
              src: require('@/assets/galeria/17.jpg'),
              title: 'Sistema terminado',
              description: 'Vista final del sistema fotovoltaico instalado',
              type: 'image'
            }
          ]
        }
      ]
    }
  },
  methods: {
    toggleProject(index) {
      this.expandedProject = this.expandedProject === index ? null : index
    },
    openLightbox(project, item) {
      this.currentItem = { project, item }
      this.lightboxActive = true

      // Pausar todos los videos cuando se abre el lightbox
      this.$refs.videoCards?.forEach(card => {
        if (card.pauseVideo) card.pauseVideo()
      })
    },
    closeLightbox() {
      this.lightboxActive = false
    }
  }
}
</script>

<style scoped>
/* Estilos generales */
.gallery-wrapper {
  background-color: #f8f9fa;
  padding: 80px 0;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0C594B;
  margin-bottom: 16px;
}

.highlight {
  color: #0A9A8A;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background-color: rgba(10, 154, 138, 0.2);
  z-index: -1;
}



/* Cards de proyectos */
.project-card {
  border-radius: 12px !important;
  margin-bottom: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

.project-card.expanded {
  box-shadow: 0 8px 24px rgba(0,0,0,0.15) !important;
}

.project-header {
  padding: 24px;
  cursor: pointer;
  position: relative;
  background-color: white;
}

.project-title {
  font-size: 1.5rem;
  color: #0C594B;
  margin-bottom: 8px;
}

.project-description {
  color: #555;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 12px;
}

.expand-icon {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  color: #0A9A8A;
}

/* Carousel de imágenes */
.image-slide {
  padding: 0 8px;
}

.image-card {
  border-radius: 8px !important;
  overflow: hidden;
  width: 300px;
  height: 250px;
  margin: 8px;
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Overlay */
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(12, 89, 75, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-overlay.active {
  opacity: 1;
}

.media-caption {
  background-color: rgba(10, 154, 138, 0.9);
  padding: 4px 12px;
  border-radius: 20px;
  margin-top: 8px;
  font-size: 0.9rem;
}

/* Tech chips */
.tech-chip {
  background-color: #e1f5fe !important;
  color: #0C594B !important;
  font-weight: 500;
}

/* Estilos para la sección de videos */
.featured-videos {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9f5f3 100%);
  padding: 40px;
  border-radius: 12px;
  margin-bottom: 60px;
  box-shadow: 0 8px 24px rgba(12, 89, 75, 0.1);
}

.video-section-title {
  font-size: 1.8rem;
  color: #0C594B;
  text-align: center;
  margin-bottom: 32px;
  position: relative;
}

.video-section-title::after {
  content: '';
  display: block;
  width: 80px;
  height: 3px;
  background: #0A9A8A;
  margin: 16px auto 0;
}
.youtube-video-container {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #fff;
}

.youtube-video-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 28px rgba(0,0,0,0.15);
}

.youtube-iframe {
  width: 100%;
  height: 315px;
  border: none;
  display: block;
}

.video-info {
  padding: 20px;
  background: white;
}

.video-info h4 {
  color: #0C594B;
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.video-info p {
  color: #555;
  font-size: 0.95rem;
}
.lightbox-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.lightbox-actions {
  background-color: #0C594B;
}

.lightbox-actions .v-btn {
  color: white !important;
}

.lightbox-content {
  padding: 0 !important;
}

.media-container {
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 70vh;
  overflow: hidden;
}

.lightbox-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.lightbox-video {
  width: 100%;
  max-height: 70vh;
}

.lightbox-details {
  background-color: white;
}

.details-title {
  color: #0C594B;
  font-size: 1.5rem;
  margin-bottom: 16px;
  position: relative;
}

.details-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: #0A9A8A;
}

.lightbox-details p {
  color: #555;
  margin-bottom: 8px;
  font-size: 1rem;
}

.lightbox-details strong {
  color: #0C594B;
  font-weight: 600;
}
.v-dialog {
  transition: all 0.3s ease !important;
}
.lightbox-actions .v-btn:hover {
  background-color: rgba(255,255,255,0.1) !important;
}


/* Responsive */
@media (max-width: 960px) {
  .lightbox-details {
    padding: 16px !important;
  }

  .details-title {
    font-size: 1.3rem;
  }
  .youtube-iframe {
    height: 250px;
  }
  .featured-videos {
    padding: 30px 20px;
  }
  .video-section-title {
    font-size: 1.5rem;
  }
  .section-title {
    font-size: 2rem;
  }
  .project-title {
    font-size: 1.3rem;
  }
  .image-card {
    width: 250px;
    height: 200px;
  }
}

@media (max-width: 600px) {
  .media-container {
    max-height: 50vh;
  }

  .lightbox-image, .lightbox-video {
    max-height: 50vh;
  }

  .details-title {
    font-size: 1.2rem;
  }

  .lightbox-details p {
    font-size: 0.9rem;
  }
  .youtube-iframe {
    height: 200px;
  }

  .video-info {
    padding: 15px;
  }

  .video-info h4 {
    font-size: 1.1rem;
  }
  .gallery-wrapper {
    padding: 60px 0;
  }
  .section-title {
    font-size: 1.8rem;
  }
  .project-header {
    padding: 16px;
  }
  .image-card {
    width: 200px;
    height: 160px;
  }
}
</style>